<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md12>
      <v-card v-if="!lead || !lead.name" color="red">
        <v-list subheader>
          <v-subheader>Lead não encontrado</v-subheader>
        </v-list>
      </v-card>
      <v-toolbar dark color="success" v-if="lead && lead.name">
        <!-- <v-spacer></v-spacer> -->
        <v-toolbar-title class="white--text">Lead</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="openMyDialog">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card v-if="lead && lead.name">
        <!-- <v-list subheader>
                    <v-subheader>Dados do Lead</v-subheader>
                </v-list> -->
        <v-alert
          v-if="lead && lead.user && lead.user.signedcontract_at"
          :value="lead.user.signedcontract_at"
          type="warning"
        >
          <p v-html="assinou" />
        </v-alert>
        <v-list two-line>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">mdi-account</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-sub-title>Nome</v-list-tile-sub-title>
              <v-list-tile-title>{{ lead.name }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <!-- <v-icon>chat</v-icon> -->
              {{ status }}
            </v-list-tile-action>
          </v-list-tile>

          <v-divider inset></v-divider>

          <!-- <v-list-tile @click=""> -->
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">mdi-phone</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-sub-title>Celular</v-list-tile-sub-title>
              <v-list-tile-title>{{ lead.phone }}</v-list-tile-title>
            </v-list-tile-content>

            <!-- <v-list-tile-action>
                        <v-icon>chat</v-icon>
                        </v-list-tile-action> -->
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">mail</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-sub-title>E-mail</v-list-tile-sub-title>
              <v-list-tile-title>{{ lead.email }}</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action v-if="lead.email || lead.user">
              <v-btn @click.prevent="showChangeEmail()" icon
                ><v-icon color="indigo">edit</v-icon></v-btn
              >
            </v-list-tile-action>
          </v-list-tile>

          <!-- <v-list-tile>
                        <v-list-tile-action></v-list-tile-action>

                        <v-list-tile-content>
                        <v-list-tile-title>ali_connors@example.com</v-list-tile-title>
                        <v-list-tile-sub-title>Work</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile> -->

          <v-divider inset></v-divider>

          <v-list-tile v-if="lead.created_at">
            <v-list-tile-action>
              <v-icon color="indigo">today</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-sub-title>Lead Criado em</v-list-tile-sub-title>
              <v-list-tile-title>{{
                lead.created_at | formatData
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-divider inset v-if="lead.created_at"></v-divider>

          <v-list-tile v-if="lead.utm_source">
            <v-list-tile-action>
              <v-icon color="indigo">router</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-sub-title>Meio de Cadastro</v-list-tile-sub-title>
              <v-list-tile-title>{{ lead.utm_source }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-divider inset v-if="lead.utm_source"></v-divider>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">attach_money</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-sub-title>Média de Consumo</v-list-tile-sub-title>
              <v-list-tile-title
                >R$ {{ lead.average_consumption }}</v-list-tile-title
              >
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset></v-divider>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">event</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-sub-title>Assinou contrato em</v-list-tile-sub-title>
              <v-list-tile-title>{{
                signContractAt | formatDate
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset></v-divider>

          <v-list-tile v-if="lead.user">
            <v-list-tile-action>
              <v-icon color="indigo">{{
                lead.user && lead.user.payment_type
                  ? lead.user.payment_type
                  : "" | formatPaymentTypeIcon
              }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-sub-title>Método de Pagamento</v-list-tile-sub-title>
              <v-list-tile-title>{{
                lead.user.payment_type | formatPaymentType
              }}</v-list-tile-title>
              <!-- <v-list-tile-title v-if="lead.user.payment_type==='boleto'">{{lead.user.payment_type==='boleto'?'Boleto:':'Cartão de Crédito'}} {{lead.user.boleto_accepted_at?' definido em ':''}} {{lead.user.boleto_accepted_at | formatDate}} {{lead.user.boleto_accepted_by?' por '+lead.user.boleto_accepted_by:'' }}</v-list-tile-title>
                            <v-list-tile-title v-if="lead.user.payment_type!=='boleto'">{{lead.user.payment_type==='boleto'?'Boleto:':'Cartão de Crédito'}}</v-list-tile-title> -->
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset></v-divider>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon :color="card.color_icon">credit_card</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-sub-title
                >Possui cartão cadastrado?</v-list-tile-sub-title
              >
              <v-list-tile-title :class="card.color">{{
                card.hasCard ? "Sim" : "Não"
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider inset></v-divider>
          <v-list-tile v-if="lead.user && !lead.user.payment_type === 'boleto'">
            <!-- <v-list-tile v-if="lead.user"> -->
            <v-list-tile-content>
              <v-list-tile-sub-title
                >URL para selecionar Boleto (obs. apenas o membro deve acessar
                essa url)</v-list-tile-sub-title
              >
              <v-list-tile-title>
                <input
                  type="text"
                  style="
                    border: 1px dashed #c0c0c0;
                    padding: 5px;
                    width: 100%;
                    font-size: 0.8rem;
                  "
                  id="urlBoleto"
                  :value="urlBoleto"
                />
                <!-- {{urlBoleto}} -->
              </v-list-tile-title>
              <!-- <v-list-tile-sub-title v-if="lead.user.payment_type!=='boleto'">{{lead.user.payment_type==='boleto'?'Boleto:':'Cartão de Crédito'}}</v-list-tile-title> -->
            </v-list-tile-content>
            <v-list-tile-action>
              <!-- <span class="btn btn-info text-white copy-btn ml-auto" @click.stop.prevent="copyTestingCode">
                                Copy
                            </span> -->
              <v-icon
                @click.stop.prevent="copyTestingCode('#urlBoleto')"
                color="grey"
                >file_copy</v-icon
              >
            </v-list-tile-action>
          </v-list-tile>
          <v-divider inset></v-divider>
          <v-list-tile v-if="lead.user && lead.user.payment_type === 'boleto'">
            <!-- <v-list-tile v-if="lead.user"> -->
            <v-list-tile-content>
              <v-list-tile-sub-title
                >URL para preencher Cartão</v-list-tile-sub-title
              >
              <v-list-tile-title>
                <input
                  type="text"
                  style="
                    border: 1px dashed #c0c0c0;
                    padding: 5px;
                    width: 100%;
                    font-size: 0.8rem;
                  "
                  id="urlCartao"
                  :value="urlCartao"
                />
                <!-- {{urlBoleto}} -->
              </v-list-tile-title>
              <!-- <v-list-tile-sub-title v-if="lead.user.payment_type!=='boleto'">{{lead.user.payment_type==='boleto'?'Boleto:':'Cartão de Crédito'}}</v-list-tile-title> -->
            </v-list-tile-content>
            <v-list-tile-action>
              <!-- <span class="btn btn-info text-white copy-btn ml-auto" @click.stop.prevent="copyTestingCode">
                                Copy
                            </span> -->
              <v-icon
                @click.stop.prevent="copyTestingCode('#urlCartao')"
                color="grey"
                >file_copy</v-icon
              >
            </v-list-tile-action>
          </v-list-tile>
          <v-divider inset></v-divider>
          <v-list-tile v-if="lead.user">
            <!-- <v-list-tile v-if="lead.user"> -->
            <v-list-tile-content>
              <v-list-tile-sub-title
                >URL para selecionar forma de pagamento (cartão ou
                boleto)</v-list-tile-sub-title
              >
              <v-list-tile-title>
                <input
                  type="text"
                  style="
                    border: 1px dashed #c0c0c0;
                    padding: 5px;
                    width: 100%;
                    font-size: 0.8rem;
                  "
                  id="urlFormaPagamento"
                  :value="urlFormaPagamento"
                />
                <!-- {{urlBoleto}} -->
              </v-list-tile-title>
              <!-- <v-list-tile-sub-title v-if="lead.user.payment_type!=='boleto'">{{lead.user.payment_type==='boleto'?'Boleto:':'Cartão de Crédito'}}</v-list-tile-title> -->
            </v-list-tile-content>
            <v-list-tile-action>
              <!-- <span class="btn btn-info text-white copy-btn ml-auto" @click.stop.prevent="copyTestingCode">
                                Copy
                            </span> -->
              <v-icon
                @click.stop.prevent="copyTestingCode('#urlFormaPagamento')"
                color="grey"
                >file_copy</v-icon
              >
            </v-list-tile-action>
          </v-list-tile>
          <v-divider inset></v-divider>
          <v-list-tile
            v-if="lead.user && lead.user.status === 'SENDED_PROPOSAL'"
          >
            <!-- <v-list-tile v-if="lead.user"> -->
            <v-list-tile-content>
              <v-list-tile-sub-title>Enviar proposta</v-list-tile-sub-title>
              <v-list-tile-title>
                <input
                  type="text"
                  style="
                    border: 1px dashed #c0c0c0;
                    padding: 5px;
                    width: 100%;
                    font-size: 0.8rem;
                  "
                  id="urlProposal"
                  :value="urlProposal"
                />
                <!-- {{urlBoleto}} -->
              </v-list-tile-title>
              <!-- <v-list-tile-sub-title v-if="lead.user.payment_type!=='boleto'">{{lead.user.payment_type==='boleto'?'Boleto:':'Cartão de Crédito'}}</v-list-tile-title> -->
            </v-list-tile-content>
            <v-list-tile-action>
              <!-- <span class="btn btn-info text-white copy-btn ml-auto" @click.stop.prevent="copyTestingCode">
                                Copy
                            </span> -->
              <v-icon
                @click.stop.prevent="copyTestingCode('#urlProposal')"
                color="grey"
                >file_copy</v-icon
              >
            </v-list-tile-action>
          </v-list-tile>
          <v-divider inset></v-divider>
        </v-list>
        <!-- <v-flex sm6 md6 class="pr-3 justify-center" justify-center> -->
        <!-- <v-list>
                    <v-list-tile>
                    <v-layout padding pr-3 align-center row justify-space-around >
                        <v-btn color="success" v-if="!card.hasCard && lead.signedcontract_at" :href="'https://onboard.enercred.com.br/cadastrar/cartao?email=' + lead.email" target="_blank">Cadastrar Cartão</v-btn>
                        <v-btn 
                            color="success" 
                            v-if="!card.hasCard && lead.signedcontract_at" 
                            @click="definirBoleto(lead)" 
                            :loading="loadingSMS" 
                            :disabled="loadingSMS"
                            flat icon large
                        >
                            Definir Boleto
                            <v-icon large right>mdi-barcode</v-icon>
                           
                        </v-btn>
                        <v-btn 
                            color="secondary" 
                            v-if="!card.hasCard && lead.signedcontract_at" 
                            @click="enviaSMS(lead.email, lead.phone)" 
                            :loading="loadingSMS" 
                            :disabled="loadingSMS"
                            flat icon large
                        >
                             Enviar SMS
                            <v-icon large right>textsms</v-icon>
                           
                        </v-btn>
                    </v-layout>
                    </v-list-tile>
                </v-list> -->
      </v-card>

      <v-snackbar
        :color="color"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        v-model="snackbar"
        dark
      >
        <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
        <div>{{ snackMessage }}</div>
        <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
      </v-snackbar>
      <cpnCreateCustomer />
      <v-dialog
        v-model="dialog_changeEmail"
        max-width="500px"
        persistent
        v-if="lead || lead.email"
      >
        <v-form v-model="valid">
          <v-card>
            <v-card-title>
              <span class="headline"
                >Tem certeza que deseja trocar o email desse membro?</span
              >
            </v-card-title>
            <v-card-text>
              <!-- <v-btn color="primary" dark @click="dialog3 = !dialog3">Open Dialog 3</v-btn> -->
              <v-text-field
                label="Email Atual"
                prepend-icon="unsubscribe"
                v-model="emailLead"
                disabled
              ></v-text-field>
              <v-text-field
                v-model="email"
                label="Novo Email"
                prepend-icon="mark_email_read"
                :rules="emailRules"
                type="email"
                required
              ></v-text-field>
            </v-card-text>
            <v-card-actions class="align">
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="dialog_changeEmail = false"
                >Cancelar</v-btn
              >
              <v-btn
                color="primary"
                v-if="lead && lead.user && lead.user.email"
                flat
                @click.prevent="changeEmail(lead.user, email)"
                :disabled="!valid || loading_changeEmail"
                :loading="loading_changeEmail"
                >Alterar</v-btn
              >
              <v-btn
                color="primary"
                v-else-if="lead.email"
                flat
                @click.prevent="changeLeadEmail(lead.email, email)"
                :disabled="!valid || loading_changeEmail"
                :loading="loading_changeEmail"
                >Alterar Email</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<script>
import { eventBus } from "../../main";
import moment from "moment";
import { sendSMSCartao, sendSMS } from "../../services/sendSMS";
import { updateUser } from "../../services/users";
import { sendEmail } from "../../services/sendEmailNovo";
import { calcconsumerunit } from "../../services/calcCreditos";
import { changeEmail, changeLeadEmail } from "../../services/users";
import CreateCustomer from "./CreateCustomer";
export default {
  data: function () {
    return {
      lead: {},
      loadingSMS: false,
      color: null,
      colors: ["purple", "info", "success", "warning", "error"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackMessage: "",
      snackbar: false,
      dialog_changeEmail: false,
      loading_changeEmail: false,
      email: "",
      emailRules: [
        (v) => !!v || "Por favor, informe o email",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail precisa ser válido",
      ],
      valid: false,
    };
  },
  components: {
    cpnCreateCustomer: CreateCustomer,
  },
  mounted() {
    eventBus.$on("Lead", (lead) => {
      // console.log('lead detail: ', lead)
      this.lead = lead;
    });
  },
  filters: {
    formatData(value) {
      if (!value) return "-";
      else {
        return moment(value.toDate()).format("DD/MM/YYYY");
      }
    },
    formatDate(value) {
      if (!value) return "-";
      // console.log(value)
      // console.log(typeof(value))
      // console.log('dd: ', typeof(date))
      if (typeof value !== "string") {
        // console.log('date1: ', new Date(date))
        return moment.utc(new Date(value)).format("DD/MM/YYYY");
      } else if (typeof value === "string") {
        // console.log('date2: ', date)
        return moment(new Date(value)).format("DD/MM/YYYY");
        // return value
      } else {
        // console.log('tipo data', typeof(value))
        // console.log('data', value)
        return value;
      }
      // const newDate = value.toDate()
      // return moment(newDate).format('DD/MM/YYYY')
    },
  },
  computed: {
    card() {
      if (this.lead && this.lead.user && this.lead.user.card_default)
        return { hasCard: true, color: "teal--text", color_icon: "teal" };
      else return { hasCard: false, color: "red--text", color_icon: "red" };
    },
    emailLead() {
      if (this.lead && this.lead.user) {
        return this.lead.user.email;
      } else if (this.lead) {
        return this.lead.email;
      } else {
        return "";
      }
    },
    status() {
      if (this.lead && this.lead.user && this.lead.user.status)
        return this.lead.user.status;
      else return "";
    },
    urlBoleto() {
      return (
        "https://onboard.enercred.com.br/boleto/confirmacao?id=" +
        this.lead.user.customer_id +
        "&utm_medium=tel&utm_source=super&utm_campaign=venda_tel"
      );
    },
    urlCartao() {
      return (
        "https://onboard.enercred.com.br/cadastro/cartao?email=" +
        this.lead.user.email +
        "&utm_medium=tel&utm_source=super&utm_campaign=venda_tel"
      );
    },
    urlFormaPagamento() {
      return (
        "https://onboard.enercred.com.br/escolher-metodo-pagamento?id=" +
        this.lead.user.customer_id +
        "&utm_medium=tel&utm_source=super&utm_campaign=venda_tel"
      );
    },
    urlProposal() {
      return (
        "https://onboard.enercred.com.br/cadastrar/proposta?uc=" +
        this.lead.consumer_unit.id +
        "&utm_medium=tel&utm_source=super&utm_campaign=venda_tel"
      );
    },
    signContractAt() {
      if (this.lead.user && this.lead.user.signedcontract_at) {
        return this.lead.user.signedcontract_at;
      } else if (this.lead.signedcontract_at) {
        return this.lead.signedcontract_at;
      } else {
        return "";
      }
    },
    assinou() {
      if (this.lead && this.lead.user && this.lead.user.signedcontract_at) {
        // console.log(this.lead.user.signedcontract_at)
        let dt_assin = moment(
          new Date(this.lead.user.signedcontract_at),
        ).format("DD/MM/YYYY HH:mm");
        let msg =
          "Cliente assinou o contrato em <b>" + dt_assin + "</b> por meio ";
        if (this.lead.user.signedcontract_by === "SUPER") {
          msg =
            msg +
            "de <b>Callcenter</b> - Vendido por: <b>" +
            this.lead.user.signedcontract_partner +
            "</b>";
        } else {
          msg = msg + "<b>Online</b>";
        }
        msg =
          msg + "<br> Cliente com status: <b>" + this.lead.user.status + "</b>";
        if (
          this.lead.user.status === "DESQUALIFICAR" &&
          this.lead.user.bot_status
        ) {
          msg = msg + " " + this.lead.user.bot_status;
        }
        return msg;
      } else {
        return "";
      }
    },
  },
  methods: {
    openMyDialog() {
      eventBus.$emit("dialog", true); // emit the event to the bus
    },
    enviaSMS(email, phone) {
      this.loadingSMS = true;
      let phoneFormat = phone.split("+55")[0];
      phoneFormat = phoneFormat.replace(/[^a-zA-Z0-9 ]/g, "");
      // console.log('phoneFormat: ', phoneFormat)
      if (phoneFormat.length === 11) {
        // console.log('phoneFormat2: ', phoneFormat)
        sendSMSCartao(email, phoneFormat)
          .then(() => {
            // console.log('res: ', res)
            this.snack("SMS enviado com sucesso", "success", "top");
            this.loadingSMS = false;
          })
          .catch((error) => {
            console.error(error);
            this.snack("Erro ao enviar SMS", "error", "top");
            this.loadingSMS = false;
          });
      } else {
        console.error("Telefone inválido: " + phoneFormat);
        const message = "Telefone inválido: " + phoneFormat;
        this.snack(message, "error", "top");
        this.loadingSMS = false;
      }
    },
    definirBoleto(lead) {
      if (!lead.user && !lead.user.customer_id) {
        this.loadingSMS = false;
        this.snack(
          "Usuário não identificafo para definir boleto como forma de pagamento.",
          "error",
          "top",
        );
      } else {
        const data = {
          payment_type: "boleto",
          boleto_accepted_at: new Date(),
          boleto_accepted_by: "telefone",
        };
        updateUser(lead.user.customer_id, data)
          .then((user) => {
            // console.log('res: ', res)
            this.lead.user = {
              ...user.data(),
            };
            this.sendMail(lead)
              .then(() => {
                // console.log('email enviado com sucesso')
              })
              .catch((error) => {
                console.error("Erro ao enviar email: ", error);
                this.snack(
                  "Erro ao enviar email sobre opção do boleto",
                  "error",
                  "top",
                );
              });
            let phoneFormat = this.lead.phone.split("+55")[0];
            phoneFormat = phoneFormat.replace(/[^a-zA-Z0-9 ]/g, "");
            let nome = this.lead.name.split(" ")[0];
            nome = nome.substring(0, 12);
            let msg =
              "JUNTOS ENERGIA :: Ola " +
              nome +
              " voce optou pela forma de pagamento boleto. Seus creditos estao previstos para chegarem em maio." +
              " Otima economia e sustentabilidade!";
            if (phoneFormat.length === 11) {
              // console.log('phoneFormat2: ', phoneFormat)
              sendSMS(msg, phoneFormat)
                // .then(() => {
                //     // console.log('sms enviado com sucesso')
                // })
                .catch((error) => {
                  console.error("Erro ao enviar SMS: ", error);
                  this.snack(
                    "Erro ao enviar SMS sobre opção do boleto",
                    "error",
                    "top",
                  );
                });
              // .then(() => {
              //     // console.log('res: ', res)
              //     this.snack("SMS enviado com sucesso", "success", "top")
              //     this.loadingSMS = false
              // })
              // .catch((error) => {
              //     console.error(error)
              //     this.snack("Erro ao enviar SMS", "error", "top")
              //     this.loadingSMS = false
              // })
            }

            this.snack(
              "Método de pagamento definido como boleto",
              "success",
              "top",
            );
            eventBus.$emit("Lead", this.lead);
            this.loadingSMS = false;
          })
          .catch((error) => {
            console.error(error);
            this.snack(
              "Erro ao definir método de pagamento como boleto",
              "error",
              "top",
            );
            this.loadingSMS = false;
          });
      }
    },
    copyTestingCode(url) {
      let testingCodeToCopy = document.querySelector(url);
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();

      try {
        // eslint-disable-next-line no-unused-vars
        var successful = document.execCommand("copy");
        // var msg = successful ? 'successful' : 'unsuccessful';
        this.snack("Copiado para memória", "green", "top");
        // alert('Testing code was copied ' + msg);
      } catch (err) {
        alert("Oops, unable to copy");
        this.snack("Ops, erro ao copiar para memória", "red", "top");
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    showChangeEmail() {
      this.dialog_changeEmail = true;
    },
    changeLeadEmail(old_email, new_email) {
      this.loading_changeEmail = true;
      if (old_email.trim() === "") {
        // alert('Por favor, preencha um email válido!')
        this.snack("Por favor, preencha o email atual!", "error", "top");
        return;
      }
      if (new_email.trim() === "") {
        // alert('Por favor, preencha um email válido!')
        this.snack("Por favor, preencha um email válido!", "error", "top");
        return;
      } else if (
        !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(new_email)
      ) {
        // alert('Por favor, preencha um email válido!')
        this.snack("Por favor, preencha um email válido!", "error", "top");
        return;
      }
      changeLeadEmail(old_email, new_email)
        .then(async (res) => {
          if (res.status === 200 && res.data.sucess) {
            // console.log('res: ', res)
            // alert('email alterado com sucesso!')
            this.lead.email = new_email;
            this.snack("Email alterado com sucesso!", "success", "top");
            this.loading_changeEmail = false;
            this.dialog_changeEmail = false;
          } else {
            this.snack(
              "Erro ao atualizar email! Contate nosso time de suporte",
              "error",
              "top",
            );
            console.error("Erro ao atualizar email ", res);
            this.loading_changeEmail = false;
            // alert('Erro: Erro ao alterar email!')
          }
        })
        .catch((err) => {
          console.error(err);
          this.loading_changeEmail = false;
          this.snack(
            "Erro ao atualizar email! Contate nosso time de suporte",
            "error",
            "top",
          );
          // alert('Erro: Erro ao alterar email!')
        });
    },
    changeEmail(userCS, new_email) {
      this.loading_changeEmail = true;
      if (this.lead.user.id === "" || new_email.trim() === "") {
        // alert('Por favor, preencha um email válido!')
        this.snack("Por favor, preencha um email válido!", "error", "top");
        return;
      } else if (
        !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(new_email)
      ) {
        // alert('Por favor, preencha um email válido!')
        this.snack("Por favor, preencha um email válido!", "error", "top");
        return;
      }
      changeEmail(userCS.id, new_email)
        .then(async (res) => {
          if (res.status === 200 && res.data?.code == "success") {
            // console.log('res: ', res)
            // alert('email alterado com sucesso!')
            this.lead.email = new_email;
            this.lead.user.email = new_email;
            this.snack("Email alterado com sucesso!", "success", "top");
            this.loading_changeEmail = false;
            this.dialog_changeEmail = false;
          } else {
            this.snack(
              "Erro ao atualizar email! Contate nosso time de suporte",
              "error",
              "top",
            );
            console.error("Erro ao atualizar email ", res);
            this.loading_changeEmail = false;
            // alert('Erro: Erro ao alterar email!')
          }
        })
        .catch((err) => {
          console.error(err);
          this.loading_changeEmail = false;
          this.snack(
            "Erro ao atualizar email! Contate nosso time de suporte",
            "error",
            "top",
          );
          // alert('Erro: Erro ao alterar email!')
        });
    },
    async sendMail(lead) {
      let msg = {};

      if (lead.consumer_unit) {
        const calc = await calcconsumerunit(this.lead.consumer_unit);
        msg = {
          from: {
            email: "contato@enercred.com.br",
            name: "Juntos Energia Compartilhada",
          },
          template_id: "d-a0571fcaca57479e81d634bed327f58f",
          personalizations: [
            {
              to: {
                email: lead.user.email,
                name: lead.user.name,
              },
              // bcc: sender,
              dynamic_template_data: {
                nome: lead.name.split(" ")[0],
                mes: "maio",
                usina: lead.consumer_unit.power_plant_id,
                percentual_aluguel: this.formatCurrency(
                  this.lead.consumer_unit.percentage,
                ),
                creditos: this.formatCurrency(calc.creditos),
                pagamento: this.formatCurrency(calc.mensalidade),
                economia_mensal: this.formatCurrency(calc.economia_mensal),
                economia_anual: this.formatCurrency(calc.economia_anual),
              },
            },
          ],
        };

        // if(billing.bills && billing.bills[0].base64String) {
        //     const filename = 'conta-concessionaria-'+ billing.competence + '.pdf'
        //     const bill_base64String = [{
        //         'content': billing.bills[0].base64String,
        //         'filename': filename,
        //         'disposition': 'attachment',
        //     }]
        //     msg.attachments = bill_base64String
        // }
      } else {
        msg = {
          from: {
            email: "contato@enercred.com.br",
            name: "Juntos Energia Compartilhada",
          },
          template_id: "d-a0571fcaca57479e81d634bed327f58f",
          personalizations: [
            {
              to: {
                email: lead.user.email,
                name: lead.user.name,
              },
              // bcc: sender,
              dynamic_template_data: {
                nome: lead.name.split(" ")[0],
                mes: "maio",
              },
            },
          ],
        };
      }
      if (msg.from.email) return sendEmail({ msg });
      else return;
    },
    formatCurrency(value) {
      if (!value) return "";
      return value.toFixed(2).replace(".", ",");
    },
  },
};
</script>
